'use strict';

class MockWrapper {
  constructor({ mockData }) {
    this._mockData = mockData;
  }

  get ready() {
    return Promise.resolve();
  }

  getCohortAllocations({ experiments }) {
    const { cohorts } = this._mockData;
    return Object.entries(cohorts).reduce((mapping, [key, val]) => {
      if (experiments.includes(key)) {
        const { data, cohortId } = val;
        mapping[key] = {
          data,
          cohortId
        };
      }
      return mapping;
    }, {});
  }

  getExperimentsById(experiments) {
    const { cohorts } = this._mockData;
    return Object.keys(cohorts).reduce((mapping, experimentId) => {
      if (experiments.includes(experimentId)) {
        Object.assign(mapping, this._getExperimentById(experimentId));
      }
      return mapping;
    }, {});
  }

  getExperiments() {
    const { cohorts } = this._mockData;
    return Object.keys(cohorts).reduce((mapping, experimentId) =>
      Object.assign(mapping, this._getExperimentById(experimentId)), {});
  }

  _getExperimentById(experimentId) {
    const { cohorts } = this._mockData;
    const cohortId = cohorts[experimentId].cohortId;
    const data = cohorts[experimentId].data || {};
    const subjectType = cohorts[experimentId].subjectType;
    return {
      [experimentId]: {
        experimentId: experimentId,
        subjectIdType: subjectType,
        killed: false,
        cohorts: [cohortId],
        cohortData: {
          [cohortId]: data
        },
        labels: data.labels || []
      }
    };
  }
}

module.exports = MockWrapper;
